import React, { useState, useEffect } from "react";
import { MemoryRouter } from "react-router-dom";
import ProgressBar from "../checkout-progress-bar";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import BillingInfo from "../billing-info-12";
import SimpleLink from "../../elements/simple-link";
import Checkbox from "../../elements/checkbox";
import ContactInformation from "../contact-information";
import DeliveryOptions from "../delivery-options";
import PrimaryButton from "../../elements/primary-button";
import OrderSummary from "../checkout-order-summary";
import { connect } from "react-redux";
import { setBillingInfoAction, setContactInfoAction, setDiffAddrAction, setShippingInfoAction, setPickupStoreAction } from "../../redux/actions/gears-checkout";
import { selectUserState } from "../../selectors/application";
import { contactInfoSelector, diffAddrSelector } from "../../selectors/gears-checkout";
import { PickupInStoreCode } from "../../utils/lynkco-constants";
import StoreInformation from "../store-information";
import { getElementOffsetY } from "../../utils";
import ShippingInfo from "../shipping-info";
let errorScrollTimeout;
const CheckoutView = ({
  user,
  diffAddr,
  contactInfoData,
  pickupStore,
  setPickupStore,
  setBillingFormData,
  setShippingFormData,
  setContactFormData,
  setDiffAddr,
  lang,
  heading,
  market,
  shippingInfo,
  billingInfo,
  contactInfo,
  orderSummary,
  userInfo,
  changeMarket,
  billingCheckbox,
  deliveryInfo,
  storeInfo,
  barProps,
  page,
  onCheckoutViewInit
}) => {
  const { gearsPaymentLink } = page.fields;
  const [showBillingInfo, setShowBillingInfo] = useState(diffAddr);
  const [isPickupInStore, setIsPickupInStore] = useState(false);
  useEffect(() => {
    onCheckoutViewInit(false);
  }, []);
  useEffect(() => {
    setIsPickupInStore(deliveryInfo.selectedOption?.code === PickupInStoreCode);
  }, [deliveryInfo]);
  const billingInfoRef = React.createRef();
  const shippingInfoRef = React.createRef();
  const contactInfoRef = React.createRef();
  const storeInfoRef = React.createRef();
  useEffect(() => {
    setShowBillingInfo(diffAddr);
    if (billingInfoRef && diffAddr) {
      billingInfoRef.current.startEdit();
    }
  }, [diffAddr, billingInfoRef]);
  const toggleBillingInfo = () => {
    setDiffAddr(!showBillingInfo);
    setShowBillingInfo(!showBillingInfo);
    billingInfoRef.current && billingInfoRef.current.startEdit();
  };
  const onSubmit = evt => {
    let billingFormData, shippingFormData;
    let valid = true;
    if (isPickupInStore) {
      const billingForm = billingInfoRef.current.validateForm();
      billingFormData = billingForm?.formData;
      valid &= !!billingForm?.isValid;
    } else {
      const sResult = shippingInfoRef.current.validateForm();
      shippingFormData = sResult.formData;
      valid &= sResult.isValid;
      if (showBillingInfo) {
        const billingForm = billingInfoRef.current.validateForm();
        billingFormData = billingForm.formData;
        valid &= billingForm.isValid;
      } else {
        billingFormData = shippingFormData;
      }
    }
    // billingFormData.billingCountryCode = "DE";
    // billingFormData.billingCountry = "Germany";
    const { isValid: isContactValid, formData: contactFormData } = contactInfoRef.current.validateForm();
    valid &= isContactValid;
    if (isPickupInStore && storeInfoRef.current) {
      const { isValid: isStoreValid, selectedStore } = storeInfoRef.current.validateForm();
      setPickupStore(selectedStore);
      valid &= isStoreValid;
    }
    if (valid) {
      setBillingFormData(billingFormData);
      setShippingFormData(shippingFormData);
      setContactFormData(contactFormData);
      window.location.href = gearsPaymentLink.value.href;
    } else {
      if (errorScrollTimeout) {
        clearTimeout(errorScrollTimeout);
      }
      errorScrollTimeout = setTimeout(() => {
        const errorElement = document.querySelector(".checkout-delivery .show-warning");
        if (errorElement) {
          window.scrollTo({
            top: getElementOffsetY(errorElement) - 60,
            behavior: "smooth"
          });
        }
      }, 200);
    }
  };
  const shippingInfoProps = {
    ...shippingInfo,
    visible: !isPickupInStore,
    ref: shippingInfoRef
  };
  const billingInfoProps = {
    ...billingInfo,
    visible: showBillingInfo || isPickupInStore,
    ref: billingInfoRef
  };
  const contactInfoProps = {
    ...contactInfo,
    ref: contactInfoRef,
    formData: contactInfoData
  };
  const storeInfoProps = {
    ...storeInfo,
    ref: storeInfoRef,
    selectedStore: pickupStore,
    visible: isPickupInStore
  };
  return (
    <section className="checkout-delivery grid">
      <div className="shipping-address-section">
        <MemoryRouter>
          <ProgressBar {...barProps} />
        </MemoryRouter>

        {!isPickupInStore && (
          <div className="heading">
            <Heading {...heading} />
          </div>
        )}
        {user && (
          <div className="info-container">
            <BodyText html={userInfo.email.html} className="user-info" />
          </div>
        )}
        <ShippingInfo {...shippingInfoProps} />
        {!isPickupInStore && (
          <div className="info-container">
            <BodyText html={userInfo.country.html} className="user-info" />
            <SimpleLink {...changeMarket} />
          </div>
        )}
        {!isPickupInStore && (
          <Checkbox
            {...{
              ...billingCheckbox,
              onChange: toggleBillingInfo,
              checked: showBillingInfo
            }}
          />
        )}
        {(showBillingInfo || isPickupInStore) && (
          <div className="billing-address">
            <BillingInfo {...billingInfoProps} />
          </div>
        )}
        {contactInfo && <ContactInformation {...contactInfoProps} />}
        <DeliveryOptions {...deliveryInfo} />
        <StoreInformation {...storeInfoProps} />
        <PrimaryButton {...{ ...deliveryInfo.submit, callback: evt => onSubmit(evt) }} />
      </div>
      <div className="summary-section">
        <OrderSummary {...orderSummary} />
      </div>
    </section>
  );
};
const mapStateToProps = state => ({
  user: selectUserState(state),
  diffAddr: diffAddrSelector(state),
  contactInfoData: contactInfoSelector(state)
});
const mapDispatchToProps = dispatch => ({
  setBillingFormData: data => dispatch(setBillingInfoAction(data)),
  setShippingFormData: data => dispatch(setShippingInfoAction(data)),
  setDiffAddr: data => dispatch(setDiffAddrAction(data)),
  setContactFormData: data => dispatch(setContactInfoAction(data)),
  setPickupStore: data => dispatch(setPickupStoreAction(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(CheckoutView);
